
import { Card, CardContent, Drawer, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { SharedFilesComponent } from "../schoolPrograms/sharedFiles/sharedFiles";
import { Inistitution } from "./institution";

export const SchoolSharedFilesComponent = () => {



    return (<>
        <Inistitution>



            <SharedFilesComponent
              eabhyasFilesAdd={false}
              eabhyasFilesDelete={false}
              eabhyasFilesShare={false}
              schoolFilesAdd={true}
              schoolFilesDelete={false}
              notificationFilesAdd={false}
              notificationFilesDelete={false}
              schoolSwitch={false}
            ></SharedFilesComponent>





        </Inistitution>

    </>);
}